'use client'

import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { cn } from '../../lib/cn'

export interface CodeWindowCopyButtonProps {
  /** Code value to copy */
  code: string
  /** Additional className for styling */
  className?: string
}

/**
 * Copy button for CodeWindow header
 * Shows copy icon normally, check icon on successful copy (1.2s)
 */
export function CodeWindowCopyButton({ code, className }: CodeWindowCopyButtonProps) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
      setTimeout(() => setCopied(false), 1200)
    } catch {
      // Silently fail if clipboard not available
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={copied ? 'Copied' : 'Copy to clipboard'}
      className={cn(
        'inline-flex items-center justify-center rounded-[var(--radius-md,calc(var(--radius)*0.75))] p-1.5 transition-colors',
        className
      )}
    >
      {copied ? (
        <Check className="size-3.5" />
      ) : (
        <Copy className="size-3.5" />
      )}
    </button>
  )
}
